import React, { useRef, useState } from "react";
import styles from "./input-with-header.module.scss";
import dateStyles from "./date-input.module.scss";
import drop_down_arrow from "../../assets/drop_down_arrow_down.svg";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs, { Dayjs } from "dayjs";

type DateInputWithHeaderProps = {
  header: string;
  placeholder: string;
  value: string; // ISO string or ""
  onChange: (isoString: string) => void;
  error?: string;
};

const DateInputWithHeader = ({
  header,
  placeholder,
  value,
  onChange,
  error,
}: DateInputWithHeaderProps) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const dayjsValue: Dayjs | null = value ? dayjs(value) : null;
  const displayValue = dayjsValue ? dayjsValue.format("DD/MM/YYYY") : "";

  const handleSelect = (date: Dayjs | null) => {
    if (date) {
      onChange(date.toISOString());
    }
    setOpen(false);
  };

  return (
    <div className={styles.cont} ref={containerRef} style={{ position: "relative" }}>
      <span className={styles["header-txt"]}>{header}</span>

      <div
        className={styles["input-cont"]}
        role="button"
        onClick={() => setOpen((prev) => !prev)}
        style={{ cursor: "pointer" }}
      >
        <input
          className={styles.input}
          readOnly
          style={{ cursor: "pointer" }}
          placeholder={placeholder}
          value={displayValue}
        />
        <img
          src={drop_down_arrow}
          alt=""
          className={styles["drop-down-arrow"]}
        />
      </div>

      {error ? <span className={styles["error-txt"]}>{error}</span> : null}

      {open && (
        <>
          <div
            className={dateStyles.overlay}
            onClick={() => setOpen(false)}
          />
          <div className={dateStyles.calendarPopover}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                value={dayjsValue}
                onChange={handleSelect}
                disableFuture
                views={["year", "month", "day"]}
                openTo="day"
              />
            </LocalizationProvider>
          </div>
        </>
      )}
    </div>
  );
};

export default DateInputWithHeader;
